import { TournamentQueryDocument } from '~/client/features/Tournaments/graphql/TournamentQuery.generated';
import { TournamentsQueryDocument } from '~/client/features/Tournaments/graphql/TournamentsQuery.generated';

type Props = {
  site: Site;
  page?: 'list' | 'details' | 'game';
  shortUrl: string;
};

const getOptInRefetchQueries = ({ site, page, shortUrl }: Props) => {
  if (page === 'list') {
    return [
      {
        query: TournamentsQueryDocument,
        variables: {
          onlyCurrent: true,
          site,
        },
      },
      {
        query: TournamentsQueryDocument,
        variables: {
          onlyFuture: true,
          site,
        },
      },
      {
        query: TournamentsQueryDocument,
        variables: {
          onlyMy: true,
          site,
        },
      },
    ];
  }
  return [
    {
      query: TournamentQueryDocument,
      variables: {
        tournamentId: shortUrl,
        site,
      },
    },
  ];
};

export default getOptInRefetchQueries;
